var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"row result-message-container"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"text-center h-100 d-flex flex-column align-items-center justify-content-center"},[_vm._t("default")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }